import React from "react";

class Intro extends React.Component {


    constructor (props) {
        super(props)
        
        this.counter = 0;
        this.state = {
            'photo_url': Math.random() >= 0.5?'/images/header/happy_woman6.png':'/images/header/happy_woman5.png'
        }

        //bind
        this.togglePhoto = this.togglePhoto.bind(this); 

    }

    togglePhoto(event) {
        //event.preventDefault();
        event.stopPropagation()
        
        // fixes double click even on mobile on the first time
        if (this.counter++===1 && event.type==='click') 
            return 

        if (this.state.photo_url==='/images/header/happy_woman5.png')
            this.setState({photo_url: '/images/header/happy_woman6.png'});
        else
            this.setState({photo_url: '/images/header/happy_woman5.png'});
        
    }

    render() {
        if (!this.props?.hidden && !this.props?.active )
            return(
            <div className="homepage-intro-wrapper">
                <div className="homepage-intro">
                    <img src={'/images/header/happy_woman5.png'} style={{display:'none'}} alt="אישה שהזמינה חופשה"/>
                    <img src={'/images/header/happy_woman6.png'} style={{display:'none'}} alt="אישה שהזמינה חופשה"/>
                    <div className="homepage-intro-content" onClick={e=>{this.togglePhoto(e)}} onMouseOver={e=>{this.togglePhoto(e)}} onMouseOut={e=>{this.togglePhoto(e)}}>
                        <div className="slogan" >
                            <div className="line1">אנחנו נמצא לכם חופשה.</div>
                            <div className="line2">אתם תשלמו פחות!</div>
                            <div className="line3">רק בעפנו מוצאים את התאריכים עם <strong style={{color:'#fed102'}}>השילובים</strong> הזולים ביותר של <strong  style={{color:'#fed102'}}>טיסה+מלון</strong> בשנה הקרובה</div>
                            <div className="line4">כי לפעמים כשמקדימים את הטיסה אפילו ביום יכולים <strong >לחסוך עד 35% במחיר המלון</strong>!</div>
                        </div>
                        <div className="image">
                            <img src={this.state.photo_url} alt="חופשות סודיות"></img>
                        </div>
                    </div>
                </div>
                {/*<div style={{height:'150px', width:'100%', marginTop:'20px',  backgroundImage:'url(/images/promotions/black-friday-banner-2000x150.jpg)'}}></div>*/}
            </div>
            )
        else
            return (<></>);
    }
}

export default Intro